module.exports = __webpack_public_path__ + "static/features-bg.f8e54d21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features-bg.png
// module id = 665
// module chunks = 72138227098318